<div class="relative group">
    <!-- ikona podnapisov -->
    <button class="button">
        {{ svg "subtitles" 44 "icon" }}
    </button>

    <!-- dropdown seznam podnapisov; the list is injected from the element's children -->
    <div class="popup_wrapper bottom-0 right-[4rem] xl:right-[7rem] top-[unset]">
        <div class="popup">
            <slot></slot>
        </div>
    </div>
</div>
